/* Accordion viewport-aware open state.
   The first <details class="accordion__item"> in each .accordion can be told
   whether to start open at desktop and mobile separately, via data attributes:
     data-open-desktop="true|false"
     data-open-mobile="true|false"
   This script toggles the native `open` attribute on viewport changes so the
   first item respects the section setting at the current breakpoint.
   Once the user manually toggles an item, we don't re-apply on resize — their
   intent wins. Mobile breakpoint matches brand.css: < 990px = mobile/tablet. */

(() => {
  if (window.__biatchAccordionState) return;
  window.__biatchAccordionState = true;

  const mql = window.matchMedia('(max-width: 989px)');

  function applyState(reason) {
    document.querySelectorAll('.accordion').forEach((acc) => {
      const first = acc.querySelector('.accordion__item');
      if (!first) return;
      // If the user has clicked anything in this accordion, leave it alone.
      if (acc.dataset.userTouched === 'true') return;

      const desktopOpen = first.dataset.openDesktop === 'true';
      const mobileOpen = first.dataset.openMobile === 'true';
      const shouldBeOpen = mql.matches ? mobileOpen : desktopOpen;

      if (shouldBeOpen) first.setAttribute('open', '');
      else first.removeAttribute('open');
    });
  }

  function flagTouch(e) {
    const acc = e.target.closest('.accordion');
    if (acc) acc.dataset.userTouched = 'true';
  }

  document.addEventListener('toggle', flagTouch, true);
  mql.addEventListener('change', () => applyState('resize'));

  // Run after DOM is parsed so .accordion elements exist.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyState('init'));
  } else {
    applyState('init');
  }
})();
